import {
  ChangeDetectionStrategy,
  Component, ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import createAIProcessSteps from './create-ai-proccess.json';
import {GlobalEvent} from "../../../../../../../shared/services/global-event-dispatcher/global-event";
import {
  GlobalEventDispatcherService
} from "../../../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Router} from "@angular/router";

export type CreateAIProcessStepSlug = 'installing' | 'recreating' | 'adding' | 'finishing' | 'done' | string;

type CreateAIProcessStepStatus = 'todo' | 'process' | 'passed' | string;

interface ICreateAIProcessStep {
  label: string;
  slug: CreateAIProcessStepSlug;
  status: CreateAIProcessStepStatus;
}

@Component({
    selector: 'db-create-ai-process',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './create-ai-process.component.html',
    styleUrls: ['./create-ai-process.component.scss'],
    standalone: false
})
export class CreateAiProcessComponent implements OnInit, OnChanges {

  @Input() step: CreateAIProcessStepSlug = 'installing';
  @Input() websiteId: number;
  @Input() frontUrl?: string;
  @HostBinding('class.modal-view') @Input() modalView?: boolean = false;
  @ViewChild('aiBuilderVideo') aiBuilderVideo: ElementRef<HTMLVideoElement>;

  public steps: ICreateAIProcessStep[] = createAIProcessSteps;
  public isMobile: boolean;

  constructor(
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['step']) {
      this._toNextStep(changes['step'].currentValue);
    }
  }

  ngOnInit() {
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.hideOnboardingBackButton, 1);
    if (this.modalView) {
      this.steps = this.steps.filter(step => step.slug !== 'installing');
    }
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  public playVideo(): void {
    setTimeout(() => {
      this.aiBuilderVideo && this.aiBuilderVideo.nativeElement.play();
    }, 1000);
  }

  private _toNextStep(slug: CreateAIProcessStepSlug): void {
    this.steps.reduce((status: CreateAIProcessStepStatus, step) => {
      if (step.slug === slug) {
        step.status = slug === 'done' ? 'passed' : 'process';
        return 'todo';
      } else {
        step.status = status;
        return status;
      }
    }, 'passed');
  }

  public redirectToHome() {
    this._router.navigate(['/websites/' + this.websiteId + '/ai-builder']);
  }

}
